export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14193.a627cc0c.jpg";